/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './applyWrites.defs.js'
export * as $defs from './applyWrites.defs.js'
